/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sms': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M853.333 85.333H170.667c-46.934 0-85.334 38.4-85.334 85.334v768L256 768h597.333c46.934 0 85.334-38.4 85.334-85.333v-512c0-46.934-38.4-85.334-85.334-85.334zM384 469.333h-85.333V384H384v85.333zm170.667 0h-85.334V384h85.334v85.333zm170.666 0H640V384h85.333v85.333z"/>'
  }
})
